import { Component, OnInit } from '@angular/core';
import {Observable} from 'rxjs';
import { MdDialogRef, MdDialog, MdDialogConfig } from '@angular/material';

@Component({
  selector: 'app-aco-cuit-dialog',
  templateUrl: './aco-cuit-dialog.component.html',
  styleUrls: ['./aco-cuit-dialog.component.scss']
})
export class AcoCuitDialogComponent implements OnInit {

  title = '';
  data: string[] = []

  constructor(public dialogRef: MdDialogRef<AcoCuitDialogComponent>) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/usuarios/aco-cuit-dialog/aco-cuit-dialog.component.ts